var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"items":_vm.suppliers,"item-text":"name","item-value":"companyId","prepend-inner-icon":"mdi-account","label":_vm.$t('silos.fields.suppliers'),"multiple":""},model:{value:(_vm.localSuppliers),callback:function ($$v) {_vm.localSuppliers=$$v},expression:"localSuppliers"}})
}
var staticRenderFns = []

export { render, staticRenderFns }